import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AppRoutes, AppVersion, ENV_CONFIG, EnvConfig, PLATFORM_TOKEN, PlatformProvider } from '@core';
import { UpdateService, VersionConfigSyncService } from '@update/infra';
import { getNewVersionNative } from '../application/utils';

@Component({
  selector: 'lib-blocked',
  templateUrl: './blocked-version.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class BlockedVersionPage {
  private readonly env: EnvConfig = inject(ENV_CONFIG);
  private readonly router: Router = inject(Router);
  private readonly updateService: UpdateService = inject(UpdateService);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  private readonly versionConfigSyncService: VersionConfigSyncService = inject(VersionConfigSyncService);

  readonly newestVersion: Signal<string | undefined> = toSignal(this.updateService.newestVersion());

  readonly appVersion: string = AppVersion;

  async goToApp(): Promise<void> {
    await this.versionConfigSyncService.sync();
    await new Promise((resolve: (value: void) => void) => setTimeout(resolve, 500));
    this.router.navigate([`/${AppRoutes.ROOT}`]);
  }

  getApk(): void {
    getNewVersionNative(this.platformProvider, this.env);
  }
}
